// extracted by mini-css-extract-plugin
export var body = "styles-module--body--kiW-J";
export var button = "styles-module--button--2AIdH";
export var closed = "styles-module--closed--mCpXN";
export var icon = "styles-module--icon--2IiAY";
export var iconLabel = "styles-module--iconLabel--eU_zK";
export var open = "styles-module--open--1qDKo";
export var reveal = "styles-module--reveal--3tdw_";
export var showChevronNextToTitle = "styles-module--showChevronNextToTitle--3NK3F";